<div
  class="header"
  [ngClass]="{
    sideBar_toggle: user.currentUser && sideNavToggleBtn,
    langEn: _translate.getDefaultLang() == 'en'
  }"
>
  <div class="header-content">
    <div class="d-flex menu">
      <mat-icon
        matSuffix
        class="menu-responsive material-icons-outlined"
        id="sideNavIcon"
        (click)="sideNavToggleBtnRes.emit(true)"
      >
        menu
      </mat-icon>
      <h3 class="title-medium">
        {{ "dashboard" | translate }}
        {{ "roles." + currentRole | translate }}
      </h3>
    </div>
    <div class="notification d-flex gap-1">
      <div class="username" [ngStyle]="{ direction: 'rtl' }">
        {{ user.currentUser.username }}
      </div>
      <!-- <app-language-icon></app-language-icon> -->
      <div
        class="notify-icon"
        (click)="openNotification(this.navFlag)"
        id="notify"
      >
        @if (hasUnseenNotification && this.navFlag == 'close') {
        <span class="counter">
          {{ hasUnseenNotification | notifictionNumber }}
        </span>
        }
        <mat-icon matSuffix class="material-icons-outlined" id="notify">
          notifications
        </mat-icon>
      </div>
    </div>
  </div>
</div>
